<template>
  <div class="scrollable-element" ref="scrollable">
    <el-header class="header_box">
      <h5 class="quest_title" @click="start">{{ questName }}</h5>
    </el-header>
    <el-card class="box-card">
      <p v-if="questIntro !== null">{{ questIntro }}</p>
    </el-card>

    <el-card class="box-card" v-if="questIntro !== null && status == 20">
      <el-row>
        <el-col :span="18">
          <div class="ele_center ele_bold">历史测评时间</div>
        </el-col>
        <el-col :span="6">
          <div class="ele_center ele_bold">操作</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <div class="ele_center quest_time">{{ time }}</div>
        </el-col>
        <el-col :span="6">
          <div class="ele_center ele_bold">
            <el-button class="large-btn" style="text-align: left" type="text" @click="buildReport"
                       v-loading.fullscreen.lock="fullscreenLoading">查看报告
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-button type="primary" class="large-btn" @click="start">
      <span v-if="questIntro !== null && status == 20">重新测评</span>
      <span v-else>开始测评</span>
    </el-button>
  </div>
</template>

<script>
import {getQuestIntroByCode, parseQuestNameByCode, isNotNull} from "@/assets/js/questIntro";
import HttpRequest from "../utils/request";
import {mapState} from "vuex";
import {getSessionData} from '@/utils/cache'

export default {
  data() {
    return {
      questName: '其他',
      questIntro: null,
      questCode: null,
      checkupId: null,
      type: null,
      questId: null,
      time: null,
      status: null,
      fullscreenLoading: false,
    }
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    })
  },
  created() {
    this.getQuestIntro()
  },
  mounted() {
    document.title = this.questName;
  },
  methods: {
    //获取答题简介
    getQuestIntro() {
      this.questCode = this.$route.params.questCode;
      if (!this.questCode) {
        this.questCode = sessionStorage.getItem('questCode');
        if (!this.questCode) {
          this.$router.go(-1);
          return;
        }
      } else {
        sessionStorage.setItem('questCode', this.questCode)
      }
      this.checkupId = this.$route.params.checkupId || -1;
      this.type = this.$route.params.type;
      this.questId = this.$route.params.questId;
      this.time = this.$route.params.time;
      this.status = this.$route.params.status;
      if (
        isNotNull(
          this.checkupId ||
          this.type ||
          this.questId ||
          this.time ||
          this.status
        )
      ) {
        if (this.checkupId == -1)
          this.getFreeQuests();
      }
      let questIntro = getQuestIntroByCode(this.questCode)
      let questName = parseQuestNameByCode(this.questCode)
      if (questIntro !== null) {
        this.questIntro = questIntro
        this.questName = questName
      } else {
        this.$alert('测评问卷不存在', {confirmButtonText: '返回', showClose: false}).then(() => {
          this.$router.go(-1);
        });
      }
    },
    getFreeQuests() {
      let url = "/constub/getFreeOrAssignQuest";
      let data = {token: this.student.token, type: "free", questCode: this.questCode};
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          let quests = res.data;
          this.type = "free";
          if (quests.length == 0) {
            this.questId = null
            this.checkupId = -1
            this.status = 10
            return
          }
          let freeCode = quests[0];
          this.checkupId = freeCode.id;
          this.questId = freeCode.questId;
          this.time = freeCode.updateTime || freeCode.createTime;
          this.status = freeCode.status;
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: "确定",
            showClose: false
          });
        }
      });
    },
    start() {
      this.$router.push(
        ((getSessionData("partner") == null || getSessionData("partner") == undefined)
          ? '/simpleQuest' : '/quest')
        + '?questId=' + this.questId
        + '&checkupId=' + this.checkupId
        + '&questCode=' + this.questCode
        + '&type=' + this.type
      )
    },
    buildReport() {
      this.fullscreenLoading = true;
      let url = "/constub/buildReport";
      let data = {token: this.student.token, questId: this.questId};
      HttpRequest.requestFormPost(url, data).then(res => {
        this.fullscreenLoading = false;
        if (res && res.result.success) {
          let pdfUrl = res.data;
          // 在延迟后打开新标签页 解决Safari浏览器不支持的问题
          setTimeout(function () {
            window.open(pdfUrl, '_blank');
          }, 1); // 设置延迟时间为1毫秒
        } else {
          this.$alert(res.result.message, {confirmButtonText: '确定', showClose: false,});
        }
      });
    },
  }

}
</script>

<style scoped>
.box-card {
  padding: 15px;
}

.header_box {
  display: flex;
  align-items: center;
}

.quest_title {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}

</style>
